import { Component, OnInit, ViewChild } from '@angular/core';

import { TituloReceberFilter, TituloReceberFilterComponent, TituloReceberFilterInitialization, TituloReceberFilterStorageService } from '../../filter';
import { isPerspectivaTodos } from '../../perspectiva';
// import { TituloReceberVisualizacaoComponent } from "../../visualizacao";
import { IntegrationTituloReceberModalComponent } from '../../../configuracoes/integration/titulo-receber';
import { TituloReceberSearchCliente } from '../../cliente';
import { TituloReceberClienteViewModalComponent } from '../../cliente/view/modal';
import { TituloReceberClienteTableComponent } from '../../cliente/view/table';
import { TituloReceberFormModalComponent } from '../../form/modal';
import { TituloReceberIntegracaoErpImportModalComponent, TituloReceberIntegracaoErpImportService } from '../../integracoes/erp/import';
import { TituloReceberAuthGuardService, TituloReceberReportHttpService } from '../../services';
import { TituloReceberResourceOptions } from '../../titulo-receber-resource-options';
import { TituloReceberDashboardComponent } from '../dashboard';
import { TituloReceberTableComponent } from '../table';

import { Subscription } from 'rxjs';
import { TituloReceberSearch } from '../../titulo-receber-search';

interface Config {
    canInsert: boolean;
}

@Component({
    selector: 'sgt-titulo-receber-view-container',
    templateUrl: './titulo-receber-view-container.component.html',
    styleUrls: ['./titulo-receber-view-container.component.less']
})
export class TituloReceberViewContainerComponent implements OnInit {
    config: Config;
    readonly filterStorageKey = 'tituloReceberFilter';
    readonly visualizacaoStorageKey = 'tituloReceberVisualizacao';
    options: TituloReceberResourceOptions;

    // Visualização
    // @ViewChild('visualizacaoComponent') visualizacaoComponent: TituloReceberVisualizacaoComponent;

    // Filter
    filter = new TituloReceberFilter();
    filterInitialization = new TituloReceberFilterInitialization();
    @ViewChild('tituloReceberFilter') tituloReceberFilter: TituloReceberFilterComponent;

    // Table
    @ViewChild('table') table: TituloReceberTableComponent;
    // Dashboard
    @ViewChild('dashboard') dashboard: TituloReceberDashboardComponent;

    // Cliente
    @ViewChild('clienteTable') clienteTable: TituloReceberClienteTableComponent;
    @ViewChild('clienteViewModal') clienteViewModal: TituloReceberClienteViewModalComponent;

    // Form
    @ViewChild('formModal') formModal: TituloReceberFormModalComponent;

    @ViewChild('integrationModal') integrationModal: IntegrationTituloReceberModalComponent;
    @ViewChild('integracaoErpImportModal') integracaoErpImportModal: TituloReceberIntegracaoErpImportModalComponent;
    /** Subscription da execução da importação dos títulos a receber do ERP */
    afterImportErpSub$: Subscription;

    constructor(private tituloReceberAuthGuardService: TituloReceberAuthGuardService,
                private tituloReceberFilterStorageService: TituloReceberFilterStorageService,
                private tituloReceberReportHttpService: TituloReceberReportHttpService,
                private tituloReceberIntegracaoErpImportService: TituloReceberIntegracaoErpImportService) { }

    ngOnInit(): void {
        this.initFilter();
        this.createConfig();
        this.createOptions();

        // Subscrevendo ao evento de finalização da importação dos títulos a receber do ERP
        this.afterImportErp();
    }

    private createConfig() {
        this.config = {
            canInsert: this.tituloReceberAuthGuardService.canInsert()
        };
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new TituloReceberResourceOptions();
        // Imprimir
        this.options.printListagem = this.tituloReceberAuthGuardService.canPrintListagem();
        // Import ERP v1
        this.options.canImportErp_v1 = this.tituloReceberAuthGuardService.canImportErp_v1();
        // Import ERP
        this.options.canImportErp = this.tituloReceberAuthGuardService.canImportErp();
    }

    private setStorage() {
        // Visualização
        // this.visualizacaoComponent.setStorage();
        // Filter
        this.tituloReceberFilterStorageService.set(this.filterStorageKey, this.filter);
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.tituloReceberFilterStorageService.hasFilter(this.filterStorageKey) || force) {
            //
        }
    }

    private initFilter() {
        this.filterInitialization.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.tituloReceberFilterStorageService.applyFilter(this.filterStorageKey, this.filter);
                    this.setDefaultFilters();

                    setTimeout(() => {
                        this.search();
                    }, 0);
                }
            }
        );
    }

    /** Ao alterar a perspectiva da pesquisa */
    onChangePerspectiva(perspectiva: number) {
        this.filter.perspectiva = perspectiva;
        if (isPerspectivaTodos(this.filter.perspectiva)) { // Todos os títulos => Periodicidade mensal
            this.tituloReceberFilter.setPeriodicidadeMensal();
        } else { // Demais => Todo o período
            this.tituloReceberFilter.setTodoPeriodo();
        }

        setTimeout(() => this.onFilterChange(), 0);
    }

    /** Ao alterar a flag agrupar os títulos a receber por clientes */
    onChangeAgruparPorCliente(agruparPorCliente: boolean) {
        this.filter.agruparPorCliente = agruparPorCliente;
        setTimeout(() => this.onFilterChange(), 0);
    }

    /** Ao alterar o modo de visualização */
    onChangeModoVisualizacao() {
        setTimeout(() => {
            this.search();
        }, 0);
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        if (!this.filterInitialization.isInitialized()) {
            return;
        }
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters(true);
        setTimeout(() => this.search(), 0);
    }

    search() {
        this.setStorage();

        if (this.filter.agruparPorCliente) {
            this.clienteTable?.search();
        } else {
            this.table?.search();
        }
    }

    refresh() {
        if (this.filter.agruparPorCliente) {
            this.clienteTable?.refresh();
        } else {
            this.table?.refresh();
        }
    }

    insert() {
        this.formModal.insert();
    }

    /** Realiza a impressão da listagem dos títulos a receber */
    printListagem() {
        if (this.filter.agruparPorCliente) {
            this.printListagemClientes();
        } else {
            this.printListagemTitulos();
        }
    }

    private printListagemTitulos() {
        const orderBy = this.table?.getOrderBy();
        const orderByDir = this.table?.getOrderByDir();

        // Imprimindo
        this.tituloReceberReportHttpService.printListagem(this.filter, orderBy, orderByDir)
            .then(() => {})
            .catch(() => {});
    }

    private printListagemClientes() {
        window.alert('Em desenvolvimento...');
    }

    /** Abre o modal para realizar a importação dos títulos a receber do ERP V1 */
    openIntegracaoErpImportModal_v1() {
        this.integrationModal.open();
    }

    /** Após realizar a importação dos títulos a receber do ERP V1 */
    afterImporErp_v1() {
        if (this.filter.agruparPorCliente) {
            this.clienteTable?.refresh();
        } else {
            this.table?.refresh();
        }
    }

    /** Abre o modal para importar os títulos a receber do ERP */
    openIntegracaoErpImportModal() {
        this.integracaoErpImportModal.open();
    }

    /** Após realizar a importação dos títulos a receber do ERP */
    private afterImportErp() {
        this.afterImportErpSub$ = this.tituloReceberIntegracaoErpImportService.afterImport
                                            .subscribe(
                                                () => {
                                                    if (this.filter.agruparPorCliente) {
                                                        this.clienteTable?.refresh();
                                                    } else {
                                                        this.table?.refresh();
                                                    }
                                                }
                                            );
    }

    /** Abre modal para editar o título a receber */
    editTitulo(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }
        this.formModal.edit(entity.id);
    }

    /** Abre modal para visualizar o título a receber */
    visualizarTitulo(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }
        this.formModal.visualizar(entity.id);
    }

    /** Abre modal para visualizar os títulos a receber do cliente */
    visualizarTitulosCliente(cliente: TituloReceberSearchCliente) {
        if (!cliente) {
            return;
        }
        this.clienteViewModal.open(cliente, this.filter.perspectiva);
    }

    ngOnDestroy(): void {
        this.afterImportErpSub$?.unsubscribe();
    }
}
